import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CUR_NETWORK, API_DOMAIN, API } from '@constants/index';
import { setApiUrl } from '@utils/index';

export const apiSearchSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_DOMAIN[CUR_NETWORK]}`,
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    getTotal: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.TOTAL, option),
        params,
      }),
    }),
    getPowerbook: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.POWERBOOK, option),
        params,
      }),
    }),
    getFaq: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.FAQ, option),
        params,
      }),
    }),
    getGuidebook: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.GUIDEBOOK, option),
        params,
      }),
    }),
    getDictionary: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.DICTIONARY, option),
        params,
      }),
    }),
    getCharacter: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.CHARACTER, option),
        params,
      }),
    }),
    getGuild: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.GUILD, option),
        params,
      }),
    }),
    getNpUser: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.NPUSER, option),
        params,
      }),
    }),
    getVideo: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.VIDEO, option),
        params,
      }),
    }),
    getNctv: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.NCTV, option),
        params,
      }),
    }),
    getEvent: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.EVENT, option),
        params,
      }),
    }),
    getImage: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.IMAGE, option),
        params,
      }),
    }),
    getShop: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(API.NSHOP, option),
        params,
      }),
    }),
  }),
});

export const {
  useGetTotalQuery,
  useGetPowerbookQuery,
  useGetFaqQuery,
  useGetGuidebookQuery,
  useGetDictionaryQuery,
  useGetCharacterQuery,
  useGetGuildQuery,
  useGetNpUserQuery,
  useGetVideoQuery,
  useGetEventQuery,
  useGetImageQuery,
  useGetShopQuery,
} = apiSearchSlice;
